import { fetchLoginStaffById } from "@/apis/security/userDetailApi";
import { createSlice } from "@reduxjs/toolkit";

const userDetailSlice = createSlice({
  name: "userDetail",
  initialState: {
    userDetail: null,
    isLoading: false,
    path: "bookings",
    isSearchFilterActionTriggered: false,
    userSecurityUpdated: false,
  },
  reducers: {
    setUserDetail: (state, action) => {
      state.userDetail = action.payload;
    },
    setUserDetailLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPath: (state, action) => {
      state.path = action.payload;
    },
    setisSearchFilterActionTriggered: (state, action) => {
      state.isSearchFilterActionTriggered = action.payload;
    },
    setUserSecurityUpdated: (state, action) => {
      state.userSecurityUpdated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoginStaffById.pending, (s) => {
        s.isLoading = true;
      })
      .addCase(fetchLoginStaffById.fulfilled, (s, { payload }) => {
        s.userDetail = payload;
        s.isLoading = false;
      })
      .addCase(fetchLoginStaffById.rejected, (s) => {
        s.isLoading = false;
      });
  },
});

export const {
  setUserDetail,
  setUserDetailLoading,
  setPath,
  setisSearchFilterActionTriggered,
  setUserSecurityUpdated,
} = userDetailSlice.actions;

export default userDetailSlice.reducer;
